import React from 'react'
import presets from '../../styles/media'
import styled from 'styled-components'
import VerticalSpace from '../utils/VerticalSpace'
import Video from '../utils/Video'

// assets
import IconLeft from '../../images/icon_left.svg'
import IconRight from '../../images/icon_right.svg'

const PageIntro = ({
	icon,
	pageTitle,
	description,
	video,
	videocaption,
	links,
}) => {
	return (
		<Wrapper>
			<PageIconWrapper>
				<PageIconLeft src={IconLeft} />
				<PageIconRight src={IconRight} />
			</PageIconWrapper>

			<PageMeta>
				<h1>{pageTitle}</h1>
				<h2>{description}</h2>
				{links ? (
					<Links>
						{links.map((el, i) => {
							return (
								<Item>
									<a href={el.href} key={i}>
										{el.title}
									</a>
								</Item>
							)
						})}
					</Links>
				) : (
					<VerticalSpace space={2} />
				)}
			</PageMeta>
			<BreakOutOfMaxWidth>
				<Video src={video}>{videocaption}</Video>
			</BreakOutOfMaxWidth>
		</Wrapper>
	)
}

const Wrapper = styled.header`
	padding: 6rem 0 0 0;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;

	${presets.desktop} {
		padding: 0;
		height: 100vh;
	}
`

const PageIcon = styled.img`
	width: 2.5rem;
	margin: 0 auto;
	transition: transform 0.3s ease-in-out;

	${presets.desktop} {
		width: 4rem;
	}
`

const PageIconLeft = styled(PageIcon)`
	transform: translateX(-0.25rem);
	${presets.desktop} {
		transform: translateX(-0.5rem);
	}
`

const PageIconRight = styled(PageIcon)`
	transform: translateX(0.25rem);
	${presets.desktop} {
		transform: translateX(0.5rem);
	}
`

const PageIconWrapper = styled.div`
	&:hover {
		${PageIconLeft} {
			transform: translateX(1.25rem);
			${presets.desktop} {
				transform: translateX(2rem);
			}
		}
		${PageIconRight} {
			transform: translateX(-1.25rem);
			${presets.desktop} {
				transform: translateX(-2rem);
			}
		}
	}
`

const PageMeta = styled.div`
	max-width: var(--layout-max-width);
	margin: 0 auto;
	text-align: center;
	padding: 3rem 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	& h1 {
		font-weight: 600;
		font-size: 1.75rem;
		letter-spacing: -0.04em;
		margin-bottom: 0.75rem;
	}

	& h2 {
		font-size: 1.125rem;
		max-width: 90%;
		margin: 1rem auto;
		letter-spacing: -0.03em;
		color: var(--color-text-secondary);
	}

	${presets.desktop} {
		padding: 4rem 0;

		& h2 {
			max-width: 60%;
		}
	}
`
const Links = styled.ul`
	list-style: none;
	padding: 2.5rem 0;
	display: flex;

	& li:not(:last-child) {
		margin-right: 2rem;
	}
`

const Item = styled.li`
	font-weight: 500;
	color: var(--color-text-tertiary);

	& a {
		text-decoration: none;
		border-bottom: 1px solid var(--color-text-tertiary);
	}
`

const BreakOutOfMaxWidth = styled.div`
	max-width: calc(var(--layout-max-width) * 1.25);
	padding: 2rem;
	margin: 0 auto;

	${presets.desktop} {
		padding: 0;
	}
`

export default PageIntro
